import { getColorClasses } from "@/lib/color-classes";
import { Badge } from "ui/components/badge";

export const TagCell = ({ getValue }) => {
    const tag = getValue();

    if (!tag) {
        return null;
    }

    const tagColor = tag.color || tag;
    const tagLabel = tag.label || tag;

    const colorClasses = getColorClasses(tagColor);

    return (
        <Badge className={colorClasses}>
            {tagLabel}
        </Badge>
    );
};
